import {Button} from '@hm/fundamental'
import {mdiDeleteOutline} from '@mdi/js'
import React from 'react'

import {RoleCommentCategoryLookupChip} from '../../components/Role/RoleCommentCategoryLookupChip'
import {GroupedRoleAssignment} from '../../modules/ManageUsers.selectors'

interface CommentCategoriesProps {
  groupedRoleAssignment: GroupedRoleAssignment
  isEditing: boolean
  handleDeleteCommentCategory?(commentCategory: string): void
}

export const CommentCategories = ({
  groupedRoleAssignment,
  isEditing,
  handleDeleteCommentCategory
}: CommentCategoriesProps) => {
  const {commentCategories} = groupedRoleAssignment.variantDataScopes

  if (!commentCategories || commentCategories.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {commentCategories?.map((commentCategory) => (
        <div key={commentCategory} className="flex gap-2">
          <div className="flex-1 border-1px border-border_highlight_10 rounded-lg py-2 px-3 flex flex-col items-start">
            <RoleCommentCategoryLookupChip
              key={commentCategory}
              commentCategory={commentCategory}
            />
          </div>
          {isEditing && (
            <Button
              type="button"
              variant="secondary"
              icon={mdiDeleteOutline}
              onClick={() => {
                handleDeleteCommentCategory?.(commentCategory)
              }}
            >
              Remove
            </Button>
          )}
        </div>
      ))}
    </div>
  )
}
